import { createSelector } from "reselect";

// Assuming your state is structured like this: { poems: { poems: [...] } }
const selectPoemsState = (state) => state.poems;

export const selectPoems = createSelector(
  [selectPoemsState],
  (poemsState) => poemsState.poems // Ensure it's an array here
);